import React from "react";

import Link from "next/link";
import PropTypes from "prop-types";
import { Nav } from "react-bootstrap";
import styled from "styled-components";

function StyledRoleLink({ as, children, className, href }) {
  return (
    <Link as={as} href={href} passHref legacyBehavior>
      <StyledNavLink className={className}>{children}</StyledNavLink>
    </Link>
  );
}

const StyledNavLink = styled(Nav.Link)`
  text-decoration: none !important;
  transition: color 0.2s ease-in-out !important;
  font-weight: bold;
  color: ${({ theme }) => theme.textColor} !important;
  background-color: ${({ theme }) => theme.primaryBackgroundColor} !important;
  text-align: center;
  border-bottom: ${({ theme }) => `1px solid ${theme.primaryColor}`};
  border-right: ${({ theme }) => `1px solid ${theme.primaryColor}`};

  &:hover {
    color: ${({ theme }) => theme.negativeTextColor} !important;
    background-color: ${({ theme }) => theme.primaryColor} !important;
  }

  :nth-child(2n) {
    border-right: none;
  }

  :last-child,
  :nth-last-child(2) {
    border-bottom: none;
  }
`;

export default StyledRoleLink;

StyledRoleLink.propTypes = {
  as: PropTypes.string,
  children: PropTypes.string.isRequired,
  className: PropTypes.string,
  href: PropTypes.string,
};

StyledRoleLink.defaultProps = {
  as: null,
  className: null,
  href: null,
};
